import React from "react";
import ClutchBadge from "assets/images/clutch-badge.png";
import UpworkBadge from "assets/images/upwork-badge.png";
const HallofFame = () => {
  return (
    <section className="hof-section">
      <div className="container">
        <div className="col-lg-10">
          <div className="section-title">
            <h1>Our Hall of Fame</h1>
            <p>Throughout our four years of experience as a design agency, we've earned quite a few of awards. Take a look at some of them here:</p>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="hof-title">
                  <span className="img-wrap">
                    <img src={ClutchBadge} width="125px" alt="not-found" />
                  </span>
                  <h5>Top Web Design Company</h5>
                </div>
                <p>
                  Recognized as a leading web design company on Clutch, delivering exceptional digital experiences that drive business growth and user
                  engagement.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card">
                <div className="hof-title">
                  <span className="img-wrap">
                    <img src={UpworkBadge} width="170px" alt="not-found" />
                  </span>
                  <h5>Top Rated</h5>
                </div>
                <p>
                  Earned top-rated status on Upwork through consistent delivery of high-quality projects and exceptional client satisfaction across
                  various technology solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HallofFame;
